export const APP_VERSION = process.env.REACT_APP_VERSION || '0.0.1';
export const APPROVALS_API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8081';
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || 'docker';
//NOTE: keep this number numeric & only increment it when old device stored state will not work with new changes...
export const PENDO_API_KEY = process.env.REACT_APP_PENDO_API_KEY;
export const ENABLE_ADD_DAMAGES = process.env.REACT_APP_ENABLE_ADD_DAMAGES || 'true';
export const ENABLE_SD_TOGGLE = process.env.REACT_APP_ENABLE_SD_TOGGLE || 'true';
export const LOG_ROCKET_APP_NAME = process.env.REACT_APP_LOG_ROCKET_APP_NAME;
export const USE_CIP_FOR_NOTES_API = process.env.REACT_APP_USE_CIP_FOR_NOTES_API || 'true';
export const TESTING_MODE = process.env.REACT_APP_TESTING_MODE === 'true' || false;
export const ENABLE_WEB_CACHE_RESET = process.env.REACT_APP_ENABLE_WEB_CACHE_RESET || 'true';
export const BACKEND_CALL_TIMEOUT = parseInt(process.env.REACT_APP_BACKEND_CALL_TIMEOUT) || 3000;